import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/ats/Desktop/cartoon-mango/docz-app-with-algolia-search/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "callback-handler"
    }}>{`Callback Handler`}</h1>
    <h2 {...{
      "id": "-things-to-remember"
    }}>{`# Things to Remember`}</h2>
    <pre><code parentName="pre" {...{}}>{` - This handler won't update only data.
 - But it will update loaders,error state, and also toast.
 - This handler will work only on api calls and custom task.
`}</code></pre>
    <h2 {...{
      "id": "-callback-handler-without-filter"
    }}>{`# Callback Handler without filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Callback-Handler",
    callback: (previousData, responseData, rest: {statusCode, ...rest} = {}, status) => ({
      loading: null,
      data: status === 200 ? [...previousData, ...responseData] : responseData,
    }),
  },
});
`}</code></pre>
    <h2 {...{
      "id": "-callback-handler-with-filter"
    }}>{`# Callback Handler with filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Callback-Handler",
    callback: (previousData, successData, rest: {statusCode, ...rest} = {}, status) => ({
      loading: null,
      data: status === 200 ? [...previousData, ...successData] : previousData,
    }),
  },
  filter: ["name"],
});
`}</code></pre>
    <h2 {...{
      "id": "-callback-handler-with-multi-filter"
    }}>{`# Callback Handler with Multi-filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Callback Handler",
     callback: (previousData, successData, rest: {statusCode, ...rest} = {}, status) => ({
      loading: null,
      data: status === 200 ? [...previousData, ...successData] : previousData,
    }),
  },
  filter: [["filter-1"], ["filter-2"], ["filter-2"]],
});
`}</code></pre>
    <h2 {...{
      "id": "-callback-handler-function---api"
    }}>{`# Callback Handler Function - Api`}</h2>
    <pre><code parentName="pre" {...{}}>{`  Note:
- The code below are the built in handler function.
- Don't copy and paste this handler, it is already available with this hoc.
- You will learn how to create your own custom handler in below.
- If you want to customize this handler you can do it.
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import invariant from "invariant";
import { typeOf } from "../helpers";
const checkKey = (callback) => {
  invariant(
    typeOf(callback) === "function",
    \`(react-boilerplate-redux-saga-hoc) \${
      typeof callback === "undefined"
        ? "'Callback-Handler' required callback key"
        : "callback is not a function"
    }\`
  );
};
export const callbackHandler = ({
  task: { callback } = {},
  successData = {},
  successDataStatusCode,
}) => ({ data: oldData = {}, statusCode, ...rest } = {}) => {
  checkKey(callback);
  return callback({
    oldData: oldData,
    newData: successData,
    rest: { ...rest, statusCode },
    status: statusCode || successDataStatusCode,
  });
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      